<template>
  <div class="user">
    <!--搜索表单-->
    <!-- <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称或手机">
          <el-input v-model="formInline.nickName" placeholder="请输入昵称或手机"></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.scene" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item,index) in Scene" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div> -->

    <div>
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加角色</el-button>
    </div>

    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="role_id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="role_name" label="角色名称" width="200"></el-table-column>
          <el-table-column prop="question_ids" label="题库" width="200"></el-table-column>
          
          <el-table-column prop="create_time" label="添加时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="name" label="操作" width="230" align="center">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="questClick(scope.row)" type="text" size="small">选择题库</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :add_type="add_type" :category="category" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <Edit v-if="open_edit" :open_edit="open_edit" :category="category" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

    <!--编辑-->
    <!-- <Question v-if="open_quest" :open_quest="open_quest" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'quest')"></Question> -->
    <!--题库选择-->
    <Question v-if="open_quest" :open_quest="open_quest" :selectModel="selectModel" @callBackFun="callBackFun" @closeDialog="closeDialogFunc($event, 'quest')"></Question>
  </div>
</template>

<script>
  import RoleApi from '@/api/study/role.js';
  import Edit from './part/Edit.vue';
  import Add from './part/Add';
  import Question from '@/components/study/Question.vue';
  import { deepClone } from '@/utils/base.js';
  export default {
    components: {
      /*编辑组件*/
      Edit: Edit,
      Add: Add,
      Question: Question,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          nickName: '',
          user_id: '',
          scene: '',
          create_time: ''
        },
        /*场景*/
        Scene: [],
        /*时间*/
        create_time: '',
        /*等级*/
        grade:[],
        open_add: false,
        open_edit: false,
        open_quest: false,
        category: {}
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*跳转订单详情*/
      gotoPage(row) {
        let self = this;
        this.$router.push({
          path: '/order/order/detail',
          query: {
            order_id: row.order_id
          }
        });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        RoleApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.category = data.category;
          self.totalDataNumber = data.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        else if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        else if (f == 'quest') {
          this.open_quest = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },
      /*打开添加*/
      addClick(e,type) {
        if(e&&typeof(e)!='undefined'){
          this.add_type=type;
          this.selectModel=deepClone(e);
        }else{
          this.parents_id=0;
        }
        this.open_add = true;
      },

      /*打开编辑*/
      editClick(item) {
        this.selectModel = item;
        this.open_edit = true;
      },

      /*选择题库*/
      questClick(item) {
        this.selectModel = item;
        this.open_quest = true;
      },

      /*删除用户*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            RoleApi.del({role_id: row.role_id},true)
              .then(data => {
                if (data.code == 1) {
                  self.loading = false;
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.getTableList();
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {});
      },
      /*保存题库*/
      callBackFun(e){
        let self = this;
        RoleApi.edit({role_id:self.selectModel.role_id, question_ids:e.ids}, true)
        .then(res => {
          if (res.code == 1) {
            self.$message({
              message: res.msg,
              type: 'success',
            });
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
      }

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/role/index.vue